/**
 * @class BaseFilterModel
 * @extends Backbone.Model
 */
export class BaseFilterModel extends Backbone.Model {

    initialize (data, options) {
        this.options = _.clone(options) || {};
    }

    /**
     * @description Will drop self attributes and empty values to NOT show them in the URL.
     * @returns {Object} Hash of non-empty objects.
     */
    getFilterParams () {

        let notEmpty = {};
        let filterParams = this.toJSON();

        Object.keys(filterParams).forEach((key) => {
            let value = filterParams[key];

            if (value !== '' && value !== null) {
                if (!_.isArray(value)) {
                    notEmpty[key] = value;
                } else if (this.options.arrayStyle === 'STRING') {
                    notEmpty[key] = value.join(',');
                } else {
                    notEmpty[key] = JSON.stringify(value);
                }
            }
        });

        return notEmpty;
    }

    /**
     * @description Serializes the model for making the query.
     *              All empty values will be dropped.
     *
     * @returns {Object}
     */
    serializeAsQuery () {

        return this.getFilterParams();
    }

    /**
     * @description Serializes the model to be mirrored in the URL.
     *              All empty values will be dropped.
     *              Should be override to replace values that are ot human readable like ISO-8601 timestamps.
     *
     * @returns {Object}
     */
    serializeAsUrl () {

        return this.getFilterParams();
    }
}


// WEBPACK FOOTER //
// ./shared/model/filter/BaseFilterModel.js